



































import { Main as AppMain, Goodbye, Navbar, Sidebar } from '@/components/index'
import { Component } from 'vue-property-decorator'
import { DeviceType } from '@/store/modules/layout'
import ResizeMixin from '@/components/mixin/ResizeHandlerMixin'
import { mixins } from 'vue-class-component'
import { namespace } from 'vuex-class'

const appModule = namespace('app')
const layoutModule = namespace('layout')

@Component({
  components: {
    AppMain,
    Goodbye,
    Navbar,
    Sidebar
  }
})
export default class Layout extends mixins(ResizeMixin) {
  @appModule.State loading!: boolean
  @layoutModule.State isLayoutVisible!: boolean
  @layoutModule.State isGoodbyeVisible!: boolean

  get showLayout(): boolean {
    return !this.loading && this.isLayoutVisible
  }

  get classObject(): object {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile
    }
  }

  handleClickOutside(): void {
    this.closeSidebar(false)
  }
}
